var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('trax-ui-top-box',{attrs:{"id":_vm.id,"endpoint":_vm.endpoint+'/'+_vm.learningUnitId,"endpoint-params":_vm.endpointParams,"icon":"laptop","props":_vm.props,"map":_vm.map,"bus":_vm.bus,"title2":_vm.courseTitle,"title3":_vm.programTitle,"background-image":_vm.backgroundImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }